// beacon.service.ts
import { Injectable } from '@angular/core';
import { CommercialUser } from '../shared/models/commercial-user.model';


@Injectable({
  providedIn: 'root'
})
export class BeaconService {
  
  private get beacon(): any {
    return (window as any).Beacon;
  }

  private isBeaconAvailable(): boolean {
    return typeof window !== 'undefined' && 
           typeof this.beacon === 'function';
  }
  
  identifyUser(user:any): void {
    if (this.isBeaconAvailable()) {
      this.beacon('identify', {
        name: user.name,
        email: user.email,
        company: user.companyName,
        jobTitle: this.getJobTitle(user),
        avatar: user.picture
      });
      console.log('Beacon user identified:', user.name);
    } else {
      console.warn('Beacon is not available');
    }
  }

private getJobTitle(user: CommercialUser): string {
  // Find the first commercial scope
  const commercialScope = (user?.scopes || []).find((scope: string) =>
    scope.startsWith('commercial:')
  );
  
  // Return the actual scope if found, otherwise fallback to user type
  return commercialScope || '';
}

  logout(): void {
    if (this.isBeaconAvailable()) {
      this.beacon('logout');
    }
  }
}